<template>
    <div>
        <b-row>
            <b-col>
                <a href="/adm/rotas" class="btn btn-primary"><i class="fa fa-map"></i> Voltar</a>
            </b-col>
        </b-row>
        <div class="row mt-3">
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Início da Rota</label>
                            <date-picker @dp-change="onStartChange" v-model="dtinicio"
                                :config="datePickerConfig"></date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Fim da Rota</label>
                            <date-picker v-model="dtfim" :config="datePickerConfig" @dp-change="onEndChange"></date-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-if="listaRota.length > 0">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Rota</th>
                                    <th>Endereco</th>
                                    <th>Cidade</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rota, i) in orderedUsers" :key="i">
                                    <td class="btn-group">
                                        <button class="btn btn-primary" @click="removeRota(rota.id)">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </td>
                                    <td>{{ rota.endereco }}</td>
                                    <td>{{ rota.cidade }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="text-primary">
                                    <td></td>
                                    <td>Total Km {{ totalKM }}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b-button size="sm" variant="primary" @click="addRota">
                                            Salvar Rota <i class="fa fa-map-marker"></i>
                                        </b-button>
                                        <b-button size="sm" variant="info" @click="clearRotas()">
                                            Excluir Rota <i class="far fa-trash-alt"></i>
                                        </b-button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h3 class="text-info">Definindo rotas</h3>
                        <div class="form-group">
                            <label>Informe o endereço do Hotel.</label>
                            <input class="form-control" @keyup="getAddress" type="text" v-model="busca" />
                            <div class="list-group" v-if="listaBusca.length > 0">
                                <div class="list-group-item" v-for="(list, index) in listaBusca" :key="index">
                                    <a href="#" @click="addMarker(list.coordenadas, nomeHotel)">{{ index + 1 }} - {{
                                        list.endereco }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div class="center-block col-md-12">
                <l-map ref="rota" style="height: 400px" :zoom="zoom" :center="inicio">
                    <l-tile-layer :url="url" :attribution="attribution" />
                    <v-geosearch :options="geosearchOptions"></v-geosearch>
                    <l-marker v-for="marker in markers" :draggable="marker.draggable" :lat-lng="marker.position"
                        :key="marker.id">
                        <l-popup :content="marker.title"></l-popup>
                    </l-marker>
                </l-map>
            </div>
        </div>

        <!------------------------------------------------------ Modal  ----------------------------- -->
        <b-modal v-model="openModalRota" size="xl" title="Salvar Rota">
            <b-card>
                <b-card-body>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="list-group">
                                <div class="list-group-item">
                                    Total de Combustível: R$ {{ totalCombustivel.toFixed(2) }}
                                    <small class="text-danger">
                                        {{ totalLitros.toFixed(2) }} Litros
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Hospedagem : R$ {{ totalHospedagem.toFixed(2) }}
                                    <small class="text-danger">
                                        {{ parametros.hospedagem }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Alimentação : R$ {{ totalAlimentacao.toFixed(2) }}
                                    <small class="text-danger">
                                        {{ parametros.alimentacao }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item bg bg-secondary">
                                    Total Pedágio : R$ {{ totalPedagio }}
                                </div>
                                <div class="list-group-item active">
                                    Total : R$ {{ (valorTOTAL + totalPedagio).toFixed(2) }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Rota</th>
                                        <th>Endereco</th>
                                        <th>Cidade</th>
                                        <th>Pedágio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rota, i) in orderedUsers" :key="i">
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ rota.endereco }}</td>
                                        <td>{{ rota.cidade }}</td>
                                        <td>
                                            <span>
                                                <input type="text" v-mask="['#.##', '##.##', '###.##', '###.##']"
                                                    v-model="rota.pedagio" v-show="!rota.showInput" />
                                            </span>
                                            <span v-if="rota.showInput">
                                                {{ rota.pedagio }}
                                            </span>
                                        </td>
                                        <td>
                                            <b-button variant="success" @click="addPedagio(rota.pedagio, i)"
                                                v-if="!rota.showInput">
                                                <i class="fa fa-check"></i>
                                            </b-button>
                                            <b-button variant="danger" @click="addPedagio(0, i)" v-if="rota.showInput">
                                                <i class="fas fa-window-close"></i>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="text-primary">
                                        <td>-</td>
                                        <td>Total Km {{ totalKM }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
            <template #modal-footer>
                <b-button size="sm" variant="primary" @click="salvaRota">
                    Confirmar
                </b-button>
                <b-button size="sm" variant="danger" @click="openModalRota = false">
                    Cancelar
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline
} from "vue2-leaflet";
import { Icon } from 'leaflet';
import {
    GeoSearchControl,
    OpenStreetMapProvider
} from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import {
    LeafleatRoutingMachine
} from "leaflet-routing-machine/dist/leaflet-routing-machine.js";
import DatePicker from "vue-bootstrap-datetimepicker/src/component";

export default {
    name: "Rotas",
    components: {
        DatePicker,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
        VGeosearch,
    },
    data() {
        return {
            zoom: 10,
            inicio: this.getCoordenadas(),
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a href="#">Abelha Rainha</a> T.I',
            //marker: this.getCoordenadas(),
            currentZoom: 10,
            currentCenter: this.getCoordenadas(),
            busca: "",
            listaBusca: [],
            rota: {},
            arrayLayers: [],
            listaRota: [],
            dtinicio: moment().add(10, "days"),
            dtfim: moment().add(20, "days"),
            rotasSelecionadas: [],
            totalKM: 0,
            valorTOTAL: 0,
            totalCombustivel: 0,
            totalLitros: 0,
            qtdHospedagem: 0,
            totalHospedagem: 0,
            totalAlimentacao: 0,
            totalPedagio: 0,
            openModalRota: false,
            markers: [{
                id: 0,
                position: this.getCoordenadas(),
                draggable: true,
                visible: true,
                title: "Abelha Rainha",
                distance: 0,
            },],
            cidades: [],
            nomeHotel: "",
            geosearchOptions: new GeoSearchControl({
                provider: new OpenStreetMapProvider(),
                style: 'bar',
                showMarker: true,
                showPopup: false,
                searchLabel: "Digite o Endereço",
                marker: {
                    icon: new L.Icon.Default(),
                    draggable: false,
                },
                autoClose: true
            }),
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            parametros: {
                kmXdia: 0,
                kmXlitro: 0,
                kmExtra: 0,
                alimentacao: 0,
                hospedagem: 0,
                combustivel: 0,
            },
        };
    },
    methods: {
        onStartChange(e) {
            var atual = e.date.format("YYYY-MM-DD");
            var antiga = e.oldDate.format("YYYY-MM-DD");
            if (atual !== antiga) {
                this.dtinicio = e.date;
                console.log("passei por startchange");
            }
        },
        onEndChange(e) {
            var atual = e.date.format("YYYY-MM-DD");
            var antiga = e.oldDate ? e.oldDate.format("YYYY-MM-DD") : moment();
            if (atual !== antiga) {
                this.dtfim = e.date;
                console.log("passei por endchange");
            }
        },
        initDates() {
            this.dtinicio = moment().add(10, "days");
            //this.dtinicio.set({hour:0,minute:0,second:0,millisecond:0});
            this.dtfim = moment().add(20, "days");
        },
        addPedagio(value, id) {
            var vm = this;
            vm.listaRota[id].pedagio = value;
            vm.listaRota[id].showInput = value === 0 ? false : true;
            vm.totalPedagio = 0.0;
            vm.listaRota.forEach(function (a, s) {
                // console.log(typeof a.pedagio);
                vm.totalPedagio += a.pedagio ? parseFloat(a.pedagio) : 0;
            });
        },
        removeRota(id) {
            var vm = this;
            var map = this.$refs.rota.mapObject;
            //console.log("removendo rota...." + id);
            var arrayRota = [];
            this.listaRota.forEach(function (x, c) {
                // console.log(c);
                if (c !== id) {
                    arrayRota.push(x);
                } else {
                    vm.markers.splice(c, 1);
                }
            });
            //console.log(arrayRota);
            this.listaRota = arrayRota;

            var arrayRotas = [];
            vm.cidades = [];
            vm.markers.forEach(function (v, i) {
                arrayRotas.push(v.position);
            });
            if (arrayRotas.length > 0) {
                vm.cidades.push({
                    id: "rota-" + arrayRotas.length,
                    position: arrayRotas,
                    visible: true,
                    distance: 0,
                    name: "",
                });
            }
            vm.arrayLayers.length > 1 ? vm.rota.remove(map) : null;

            vm.rota = L.Routing.control({
                waypoints: arrayRotas,
                language: "pt-BR",
                routeWhileDragging: true,
                reverseWaypoints: true,
                showAlternatives: true,
                router: L.Routing.mapbox(
                    "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                    language: "pt-BR"
                }
                ),
                altLineOptions: {
                    styles: [{
                        color: "black",
                        opacity: 0.15,
                        weight: 9
                    },
                    {
                        color: "white",
                        opacity: 0.8,
                        weight: 6
                    },
                    {
                        color: "blue",
                        opacity: 0.5,
                        weight: 2
                    },
                    ],
                },
            }).on("routeselected", function (e) {
                var route = e.route;
                vm.rotasSelecionadas = [];
                vm.totalKM = parseFloat(route.summary.totalDistance / 1000).toFixed(1);
                var arrayPoints = route.waypoints;
                //console.log(arrayPoints);
                //array com as cordenadas da Rota.
                arrayPoints.forEach(function (a, x) {
                    vm.rotasSelecionadas.push({
                        lat: a.latLng.lat,
                        lng: a.latLng.lng
                    });
                });
                vm.nomeHotel = "";
                vm.getMarkers();
            });
            L.Routing.Localization = "pt-BR";
            vm.rota.addTo(map);
            vm.addLayer();
        },

        getCoordenadas() {
            // Coordenadas CTIC
            var latitude = -16.716297; //$('#latitude').val();
            var longtude = -49.261100; //$('#longitude').val();
            
            //COORDENADAS ABELHA RAINHA.
            //var latitude = -16.755669; //$('#latitude').val();
            //var longtude = -49.242341; //$('#longitude').val();
            return L.latLng(latitude, longtude);
        },
        //Funcao que cria array com dados da rota, para exibir ao usuário.
        getMarkers() {
            var vm = this;
            vm.listaRota = [];
            if (vm.rotasSelecionadas.length <= 0) {
                return;
            }
            vm.rotasSelecionadas.forEach(function (z, x) {
                vm.getAddLatLong(z.lat, z.lng, x);
            });
        },
        getAddLatLong(lat, lng, id) {
            var vm = this;
            var data = {
                latitude: lat,
                longitude: lng
            };

            axios
                .get("/adm/rotas/latlng", {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    vm.listaRota.push({
                        id: typeof id === "undefined" ? vm.listaRota.length + 1 : id,
                        endereco: obj.endereco,
                        cidade: obj.cidade,
                        coordenadas: obj.coordenadas,
                    });
                    //console.log(vm.listaRota);
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        getAddress(event) {
            var vm = this;
            if (vm.busca == "") {
                return;
            }
            vm.listaBusca = [];
            //console.log(this.busca)
            var data = {
                endereco: this.busca
            };
            axios
                .get("/adm/rotas/busca", {
                    params: data,
                })
                .then(function (response) {
                    vm.listaBusca = response.data;
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        getLocal(lat, lng) {
            var vm = this;
            var data = {
                latitude: lat,
                longitude: lng
            };

            axios
                .get("/adm/rotas/latlng", {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    return obj.obj.cidade;
                })
                .catch(function (error) {
                    console.log(error.response);
                    return "";
                });
        },
        addMarker(oObj, title) {
            var vm = this;
            var arrayRotas = [];
            var map = this.$refs.rota.mapObject;

            const newMarker = {
                id: vm.markers.length,
                position: L.latLng(oObj.latitude, oObj.longitude),
                draggable: true,
                visible: true,
                title: title,
                distance: 0,
            };
            vm.markers.push(newMarker);
            vm.busca = "";
            vm.listaBusca = [];
            vm.cidades = [];
            vm.markers.forEach(function (v, i) {
                arrayRotas.push(v.position);
            });

            vm.arrayLayers.length > 1 ? vm.rota.remove(map) : null;

            vm.rota = L.Routing.control({
                waypoints: arrayRotas,
                language: "pt-BR",
                routeWhileDragging: true,
                reverseWaypoints: true,
                showAlternatives: true,
                router: L.Routing.mapbox(
                    "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                    language: "pt-BR"
                }
                ),
                altLineOptions: {
                    styles: [{
                        color: "black",
                        opacity: 0.15,
                        weight: 9
                    },
                    {
                        color: "white",
                        opacity: 0.8,
                        weight: 6
                    },
                    {
                        color: "blue",
                        opacity: 0.5,
                        weight: 2
                    },
                    ],
                },
            }).on("routeselected", function (e) {
                var route = e.route;
                vm.rotasSelecionadas = [];
                vm.totalKM = parseFloat(route.summary.totalDistance / 1000).toFixed(1);
                var arrayPoints = route.waypoints;
                //console.log(arrayPoints);
                //array com as cordenadas da Rota.
                arrayPoints.forEach(function (a, x) {
                    vm.rotasSelecionadas.push({
                        lat: a.latLng.lat,
                        lng: a.latLng.lng
                    });
                });
                vm.nomeHotel = "";
                vm.getMarkers();
            });
            vm.rota.addTo(map);
            vm.addLayer();
        },
        clearList() {
            this.cidades = [];
            this.markers = [];
            this.rotasSelecionadas = [];
        },
        clearRotas() {
            var map = this.$refs.rota.mapObject;
            var vm = this;
            //console.log(map._layers);
            this.$swal({
                title: "Atenção",
                text: "Você deseja deletar esta rota ?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar.",
                cancelButtonText: "Não!",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    //this.$swal('Deleted', 'You successfully deleted this file', 'success')
                    if (vm.arrayLayers.length > 0) {
                        this.markers = [{
                            id: 0,
                            position: this.getCoordenadas(),
                            draggable: true,
                            visible: true,
                            title: "Abelha Rainha",
                            distance: 0,
                        },];
                        vm.cidades = [];
                        vm.rotasSelecionadas = [];
                        vm.listaRota = [];
                        vm.arrayLayers.forEach(function (a, b) {
                            if (b > 0) {
                                vm.rota ? vm.rota.remove(map) : map.remove();
                            }
                        });
                    }
                }
            });
        },
        addLayer() {
            var map = this.$refs.rota.mapObject;
            this.arrayLayers.push(map._layers);
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        addRota() {
            var vm = this;
            if (this.listaRota.length <= 0) {
                this.$swal("Ops..", "Por Favor, Crie uma rota primeiro.", "error");
                return;
            }
            vm.getCalc();
            vm.listaRota.forEach(function (a, c) {
                a.showInput = false;
            });
            this.openModalRota = true;
        },
        getCalc() {
            var vm = this;
            // console.log(vm.dtinicio, "data de inicio");
            var timeDiff = moment(vm.dtinicio.format("YYYYMMDD"), "YYYYMMDD").from(
                vm.dtfim.format("YYYYMMDD"),
                "YYYYMMDD"
            );
            vm.totalLitros = vm.totalKM / vm.parametros.kmXlitro;
            vm.qtdHospedagem = parseInt(timeDiff);
            //console.log(vm.parametros);
            vm.totalCombustivel = vm.totalLitros * vm.parametros.combustivel;
            vm.totalHospedagem = vm.qtdHospedagem * vm.parametros.hospedagem;
            vm.totalAlimentacao = vm.parametros.alimentacao * vm.qtdHospedagem;
            vm.valorTOTAL =
                vm.totalCombustivel + vm.totalHospedagem + vm.totalAlimentacao;
        },
        getParametros() {
            console.log("buscando parametros...");
            var vm = this;
            axios
                .get("/adm/parametros/rotas/list")
                .then(function (response) {
                    let obj = response.data;
                    vm.parametros = {
                        kmXdia: obj.km_dia,
                        kmXlitro: obj.km_litro,
                        kmExtra: obj.km_extra,
                        alimentacao: parseFloat(obj.valor_alimentacao).toFixed(2),
                        hospedagem: parseFloat(obj.valor_hospedagem).toFixed(2),
                        combustivel: parseFloat(obj.valor_combustivel).toFixed(2),
                    };
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        salvaRota() {
            var vm = this;
            if (!this.validRota()) {
                return;
            }
            $(".loading").show();
            var data = {
                rota: this.orderedUsers,
                total: this.valorTOTAL,
                distance: this.totalKM,
                dtinicio: this.dtinicio.format("YYYY-MM-DD"),
                dtfim: this.dtfim.format("YYYY-MM-DD"),
                alimentacao: this.totalAlimentacao,
                hospedagem: this.totalHospedagem,
                combustivel: this.totalCombustivel,
            };
            axios
                .post("/adm/rotas/save", data)
                .then(function (response) {
                    let obj = response.data;
                    // console.log(obj);
                    if (obj.success) {
                        $(".loading").hide();
                        vm.$swal({
                            title: "Rota Salva com sucesso.",
                            text: "Você deseja consultar esta rota agora?",
                            type: "success",
                            showCancelButton: true,
                            confirmButtonText: "Sim, verificar.",
                            cancelButtonText: "Não!",
                            showCloseButton: true,
                            showLoaderOnConfirm: true,
                        }).then((result) => {
                            if (result.value) {
                                window.location.href = "/adm/rotas/edit/" + obj.id;
                            }
                        });
                    }
                })
                .catch(function (error) {
                    $(".loading").hide();
                    if (error.response.status === 500) {
                        vm.$swal("Ops", 'Houve um erro desconhecido', "error");
                    } else {
                        vm.$swal("Ops", error.response.data.errors, "error");
                    }
                    console.log(error);
                });

        },
        validRota() {
            if (this.rotasSelecionadas.length <= 0) {
                this.$swal(
                    "Ops",
                    "Nenhuma rota selecionada. Por favor, selecione uma rota.",
                    "error"
                );
                return false;
            }
            if (this.valorTOTAL <= 0) {
                this.$swal(
                    "Ops",
                    "Houve um erro ao calcular o custo de sua rota. Atualize a página e tente novamente.",
                    "error"
                );
                return false;
            }
            return true;
        },
    },
    computed: {
        orderedUsers() {
            return _.orderBy(this.listaRota, "id");
        },
    },
    mounted() {
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.getParametros();
        this.addLayer();
    },
};
</script>

<style>
html {
    font-family: sans-serif;
    font-size: 11pt;
}

.leaflet-routing-container,
.leaflet-routing-error {
    width: 320px;
    background-color: white;
    padding-top: 4px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.leaflet-control-container .leaflet-routing-container-hide {
    width: 32px;
    height: 32px;
}

.leaflet-routing-container h2 {
    font-size: 14px;
}

.leaflet-routing-container h3 {
    font-size: 12px;
    font-weight: normal;
}

.leaflet-routing-collapsible .leaflet-routing-geocoders {
    margin-top: 20px;
}

.leaflet-routing-alt,
.leaflet-routing-geocoders,
.leaflet-routing-error {
    padding: 6px;
    margin-top: 2px;
    margin-bottom: 6px;
    border-bottom: 1px solid #ccc;
    max-height: 320px;
    overflow-y: auto;
    transition: all 0.2s ease;
}

.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-alt,
.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-geocoders {
    display: none;
}

.leaflet-bar .leaflet-routing-alt:last-child {
    border-bottom: none;
}

.leaflet-routing-alt-minimized {
    color: #888;
    max-height: 64px;
    overflow: hidden;
    cursor: pointer;
}

.leaflet-routing-alt table {
    border-collapse: collapse;
}

.leaflet-routing-alt tr:hover {
    background-color: #eee;
    cursor: pointer;
}

.leaflet-routing-alt::-webkit-scrollbar {
    width: 8px;
}

.leaflet-routing-alt::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #eee;
}

.leaflet-routing-alt::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #888;
}

.leaflet-routing-icon {
    /* background-image: url('leaflet.routing.icons.png');*/
    -webkit-background-size: 240px 20px;
    background-size: 240px 20px;
    background-repeat: no-repeat;
    margin: 0;
    content: "";
    display: inline-block;
    vertical-align: top;
    width: 20px;
    height: 20px;
}

.leaflet-routing-icon-continue {
    background-position: 0 0;
}

.leaflet-routing-icon-sharp-right {
    background-position: -20px 0;
}

.leaflet-routing-icon-turn-right {
    background-position: -40px 0;
}

.leaflet-routing-icon-bear-right {
    background-position: -60px 0;
}

.leaflet-routing-icon-u-turn {
    background-position: -80px 0;
}

.leaflet-routing-icon-sharp-left {
    background-position: -100px 0;
}

.leaflet-routing-icon-turn-left {
    background-position: -120px 0;
}

.leaflet-routing-icon-bear-left {
    background-position: -140px 0;
}

.leaflet-routing-icon-depart {
    background-position: -160px 0;
}

.leaflet-routing-icon-enter-roundabout {
    background-position: -180px 0;
}

.leaflet-routing-icon-arrive {
    background-position: -200px 0;
}

.leaflet-routing-icon-via {
    background-position: -220px 0;
}

.leaflet-routing-geocoders div {
    padding: 4px 0px 4px 0px;
}

.leaflet-routing-geocoders input {
    width: 303px;
    width: calc(100% - 4px);
    line-height: 1.67;
    border: 1px solid #ccc;
}

.leaflet-routing-geocoders button {
    font: bold 18px "Lucida Console", Monaco, monospace;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    margin: 0;
    margin-right: 3px;
    float: right;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.leaflet-routing-add-waypoint:after {
    content: "+";
}

.leaflet-routing-reverse-waypoints:after {
    font-weight: normal;
    content: "\21c5";
}

.leaflet-routing-geocoders button:hover {
    background-color: #eee;
}

.leaflet-routing-geocoders input,
.leaflet-routing-remove-waypoint,
.leaflet-routing-geocoder {
    position: relative;
}

.leaflet-routing-geocoder-result {
    font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
    position: absolute;
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s ease;
    z-index: 1000;
    /* Arbitrary, but try to be above "most" things. */
}

.leaflet-routing-geocoder-result table {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    background-color: white;
    cursor: pointer;
}

.leaflet-routing-geocoder-result-open {
    max-height: 800px;
}

.leaflet-routing-geocoder-selected,
.leaflet-routing-geocoder-result tr:hover {
    background-color: #eee;
}

.leaflet-routing-geocoder-no-results {
    font-style: italic;
    color: #888;
}

.leaflet-routing-remove-waypoint {
    background-color: transparent;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.leaflet-routing-remove-waypoint:after {
    position: absolute;
    display: block;
    width: 15px;
    height: 1px;
    z-index: 1;
    right: 1px;
    top: 4px;
    bottom: 0;
    margin: auto;
    padding: 2px;
    font-size: 18px;
    font-weight: bold;
    content: "\00d7";
    text-align: center;
    cursor: pointer;
    color: #ccc;
    background: white;
    padding-bottom: 16px;
    margin-top: -16px;
    padding-right: 4px;
    line-height: 1;
}

.leaflet-routing-remove-waypoint:hover {
    color: black;
}

.leaflet-routing-instruction-distance {
    width: 48px;
}

.leaflet-routing-collapse-btn {
    position: absolute;
    top: 0;
    right: 6px;
    font-size: 24px;
    color: #ccc;
    font-weight: bold;
}

.leaflet-routing-collapse-btn:after {
    content: "\00d7";
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn {
    position: relative;
    left: 4px;
    top: 4px;
    display: block;
    width: 26px;
    height: 23px;
    /* background-image: url('routing-icon.png');*/
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn:after {
    content: none;
}

.leaflet-top .leaflet-routing-container.leaflet-routing-container-hide {
    margin-top: 10px !important;
}

.leaflet-right .leaflet-routing-container.leaflet-routing-container-hide {
    margin-right: 10px !important;
}

.leaflet-bottom .leaflet-routing-container.leaflet-routing-container-hide {
    margin-bottom: 10px !important;
}

.leaflet-left .leaflet-routing-container.leaflet-routing-container-hide {
    margin-left: 10px !important;
}

@media only screen and (max-width: 640px) {
    .leaflet-routing-container {
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 100%;
    }
}</style>



// WEBPACK FOOTER //
// resources/assets/js/components/rotas/Rotas.vue